import { render, staticRenderFns } from "./SidebarV2.vue?vue&type=template&id=ba433aba&scoped=true"
import script from "./SidebarV2.vue?vue&type=script&lang=js"
export * from "./SidebarV2.vue?vue&type=script&lang=js"
import style0 from "./SidebarV2.vue?vue&type=style&index=0&id=ba433aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba433aba",
  null
  
)

export default component.exports